import React from 'react';

export const DefaultCell = ({ value, field }) => {
  const content = value || '—';
  return (
    <div className="overflow-ellipsis" title={content} data-testid={`${field}-cell`}>
      {content}
    </div>
  );
};
